<template>
  <div>
    <section class="hero hero-atlantico is-bold">
      <div class="container">
        <div class="hero-body">
          <h1 class="title">Photo Albums</h1>
          <p>Click any of the album cards to go to the photo album's page.</p>
        </div>
      </div>
    </section>

    <div class="container">
      <div class="container card--atlantico" v-for="album in albums" :key="album.id">
        <router-link :to="'/photos/' + album.id + '?title=' + album.title">
          <article class="media">
            <figure class="image media-left">
              <img :src="backendURL + album.dir + '/' + album.thumb" :alt="album.title">
            </figure>
            <div class="media-content">
              <p class="media-content-title">{{ album.title }}</p>
              <p>{{ album.text }}</p>
            </div>
          </article>
        </router-link>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  computed: {
    backendURL () {
      return this.$store.getters.backend_url
    },
    albums () {
      return this.$store.getters.photo_albums
    }
  }
}
</script>
